module.exports = __webpack_public_path__ + "static/stringofpearls.4a1be7bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stringofpearls.jpg
// module id = 361
// module chunks = 35783957827783